(function () {
  function toNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function getHeaderHeight() {
    var header =
      document.querySelector(".header-static") ||
      document.querySelector("header.site-header") ||
      document.querySelector(".site-header");
    return header ? header.offsetHeight : 0;
  }

  function normalizeTargetSelector(raw) {
    if (!raw) return "";
    var source = String(raw).trim();
    if (!source) return "";
    if (source.startsWith(".") || source.startsWith("#")) return source;
    var firstToken = source.split(/\s+/)[0];
    return "." + firstToken.replace(/^\./, "");
  }

  function scrollToTarget(selector, extraOffset) {
    var target = document.querySelector(selector);
    if (!target) return;
    var destinationTop = target.getBoundingClientRect().top + window.scrollY - getHeaderHeight() - extraOffset;
    window.scrollTo({
      top: Math.max(0, Math.round(destinationTop)),
      behavior: "smooth"
    });
  }

  function initBannerSection(section) {
    if (!section || section.dataset.pillarBannerScrollReady === "true") return;
    section.dataset.pillarBannerScrollReady = "true";

    var extraOffset = toNumber(section.dataset.scrollOffset, 12);
    var scrollButtons = section.querySelectorAll("[data-target-class]");

    scrollButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var selector = normalizeTargetSelector(button.dataset.targetClass);
        if (!selector) return;
        scrollToTarget(selector, extraOffset);
      });
    });
  }

  function boot() {
    var sections = document.querySelectorAll(".section-pillar-page-banner");
    sections.forEach(initBannerSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
